import { List } from 'immutable';
import GroupIdpList from './model';

const create = (data) => new GroupIdpList(data).set('idpList', new List());

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/GroupIdpList/create.js